<template>
    <v-container class="pb-6">
        <template v-if="bill">
            <v-row>
                <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    :md="bill.items && bill.items.length ? 6 : 12"
                >
                    <v-card>
                        <v-row>
                            <v-col>
                                <div class="overline mb-4 ml-4">
                                    Fatura do whitelabel
                                </div>
                                <h3 class="title ml-4 mb-4">
                                    {{ bill.reseller.trade_name }}
                                </h3>
                            </v-col>
                            <v-col class="text-right mr-4">
                                <resource-actions
                                    :model="bill"
                                    pageContext="edit"
                                    @click="
                                        $refs.actionHandler[$event.type](bill)
                                    "
                                />
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-list-item>
                                    <v-list-item-avatar size="60">
                                        <v-icon
                                            class="grey lighten-1 white--text"
                                            >mdi-calendar-month</v-icon
                                        >
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-subtitle
                                            class="overline black--text"
                                            >Referência</v-list-item-subtitle
                                        >
                                        <v-list-item-title
                                            class="display-1 font-weight-light text--darken-2 grey--text"
                                        >
                                            {{
                                                ('0' + bill.month).slice(-2)
                                            }}/{{ bill.year }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-list-item>
                                    <v-list-item-avatar size="60">
                                        <v-icon
                                            class="grey lighten-1 white--text"
                                            >mdi-currency-usd</v-icon
                                        >
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-subtitle
                                            class="overline black--text"
                                            >Valor Total</v-list-item-subtitle
                                        >
                                        <v-list-item-title
                                            class="display-1 black--text"
                                        >
                                            {{ totalValue }}
                                            <div>
                                                <v-chip
                                                    class="mt-4"
                                                    color="success"
                                                    text-color="white"
                                                    v-if="bill.status"
                                                >
                                                    <v-avatar left>
                                                        <v-icon
                                                            >mdi-checkbox-marked-circle</v-icon
                                                        > </v-avatar
                                                    >Pago
                                                </v-chip>
                                                <v-chip
                                                    color="blue-grey lighten-2"
                                                    text-color="white"
                                                    v-else
                                                    class="mt-4"
                                                >
                                                    <v-avatar left>
                                                        <v-icon
                                                            >mdi-clock</v-icon
                                                        > </v-avatar
                                                    >Pendente
                                                </v-chip>
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>

                        <v-divider></v-divider>

                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="overline mb-4">Valores</div>
                                <v-currency-field
                                    label="Valor"
                                    v-bind="$t('money-config')"
                                    v-model="bill.value"
                                    disabled
                                ></v-currency-field>

                                <v-currency-field
                                    label="Desconto"
                                    v-bind="$t('money-config')"
                                    v-model="bill.discount"
                                ></v-currency-field>

                                <v-currency-field
                                    label="Juros"
                                    v-bind="$t('money-config')"
                                    v-model="bill.interest"
                                ></v-currency-field>
                            </v-list-item-content>
                        </v-list-item>
                        <v-card-text>
                            <label class="subtitle-2">
                                <v-icon left>mdi-account-lock</v-icon>Situação
                            </label>
                            <v-radio-group v-model="bill.status" dense row>
                                <v-card outlined class="mr-2 pa-5">
                                    <v-radio
                                        label="Pendente"
                                        :value="false"
                                    ></v-radio>
                                </v-card>
                                <v-card outlined class="mr-2 pa-5">
                                    <v-radio
                                        label="Pago"
                                        :value="true"
                                    ></v-radio>
                                </v-card>
                            </v-radio-group>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="success"
                                :loading="loading"
                                @click="save"
                            >
                                <v-icon left small>mdi-check</v-icon>Salvar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="6"
                    v-if="bill.items && bill.items.length"
                >
                    <v-data-table
                        :headers="headers"
                        :items="bill.items"
                        :single-expand="false"
                        :expanded.sync="expanded"
                        item-key="id"
                        show-expand
                        class="elevation-1"
                    >
                        <template v-slot:[`item.action`]="{ item }">
                            <v-btn icon tile @click="deleteItem(item)">
                                <v-icon color="red">mdi-close </v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length">
                                <p
                                    v-html="
                                        item.description
                                            .split('\n')
                                            .join('<br>')
                                    "
                                    class="py-5"
                                ></p>
                            </td>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <BillActions ref="actionHandler" @modelChanged="reloadPage()" />
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
        <confirm
            ref="confirm"
            :confirmText="$t('dialogs-confirm.buttons.remove')"
            width="400"
        ></confirm>
    </v-container>
</template>

<script>
import Bill from '@/models/Bill'
import BillActions from '@/components/actions/bill/BillActions'
import Confirm from '@/components/dialogs/Confirm'
import ResourceActions from '@/shared/components/ResourceActions'

export default {
    props: ['id'],

    components: {
        confirm: Confirm,
        ResourceActions,
        BillActions,
    },

    data: () => {
        return {
            bill: null,
            expanded: [],
            loading: false,
        }
    },

    methods: {
        async getBill() {
            let item = await this.model.find(this.id)

            this.bill = item
        },

        reloadPage() {
            window.location.reload()
        },

        async save() {
            this.loading = true

            let clone = this.bill.clone()

            let res = null

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$bus.$emit('notify', 'success', 'Fatura salva com sucesso')

            this.$router.push({ name: 'bills' })
        },

        async deleteItem(item) {
            let confirm = await this.$refs.confirm.open(
                'Remover?',
                'Tem certeza que deseja remover este item?',
            )

            if (!confirm) return

            let clone = item.clone()

            let res = null

            res = await clone.delete().catch(err => {
                console.log(err)
            })

            if (!res) return

            this.$bus.$emit('notify', 'success', 'Item deletado com sucesso')

            this.getBill()
        },
    },

    computed: {
        model() {
            return new Bill()
        },

        headers() {
            return [
                {
                    text: '#',
                    value: 'customer.id',
                },
                {
                    text: 'Cliente',
                    value: 'customer.trade_name',
                },
                {
                    text: 'Valor',
                    value: 'formattedValue',
                    width: 250,
                },
                {
                    text: 'Deletar',
                    value: 'action',
                    sortable: false,
                },
            ]
        },

        totalValue() {
            return this.$n(
                parseFloat(this.bill.value) +
                    parseFloat(this.bill.interest) -
                    parseFloat(this.bill.discount),
                'currency',
            )
        },
    },

    created() {
        this.getBill()
    },
}
</script>

<style></style>
